const contentWithSideImage = `
  heading
  sectionContent
  image {
    url @transform(mode: "crop", width: 900, immediately: true)
    title
    width
    height
    mimeType
    embeddedAsset {
      title
      url
      providerName
    }
  }
  imageAligment
  cta {
    type
    url
    text
    target
  }
`

export const CContentWithSideImageFragment = {
  default: `
    fragment contentWithSideImage on contentWithSideImage_MatrixField {
    ...on contentWithSideImage_block_Entry {
      ${contentWithSideImage}
    }
  }
  `,
  simple: `
    fragment simpleContentWithSideImage on simpleContentWithSideImage_MatrixField {
    ...on simpleContentWithSideImage_block_Entry {
      ${contentWithSideImage}
    }
  }
  `,
}

export const CContentWithSideImage2Fragment = {
  simple: `
    fragment simpleContentWithSideImage2 on simpleContentWithSideImage2_MatrixField {
    ...on simpleContentWithSideImage2_block_Entry {
      ${contentWithSideImage}
    }
  }
  `,
}
